import { GetterTree } from 'vuex/types/index'

import { RootState } from '~/store/store.types'

import { RequestParameters } from '~/utils/SohoApi/SohoApi'
import { getResource, filterId } from '~/utils/store'

import { PerksState, Perk, PerksFilter, PerkResource } from './perks.types'

const getters: GetterTree<PerksState, RootState> = {
  
  perks (state): Perk[] {
    return Object.values(state.data).map(({ id }) => getResource<PerkResource>(state, id))
  },

  resourceById (state, _, __, rootGetters) {
    return (id: string, included: string | string[] = []): Perk =>
      getResource<PerkResource>(state, id, rootGetters, included)
  },
  
  perksByParams (state, _, __, rootGetters) {
    return (params: RequestParameters<Perk, PerksFilter>): Perk[] => {
      const ids: string[] = state.filters[filterId(params)] || []

      if (ids.length <= 0) {
        return []
      }

      return ids.map(id => getResource<PerkResource>(state, id, rootGetters, params.include || []))
    }
  }
}

export default getters
